module.exports = __webpack_public_path__ + "static/video-overlay-affbbbfebca7ad0f372022e4ac929a1f.png";